module.exports = __webpack_public_path__ + "~@/assets/img/whatExif-3.cc6b3ee6.png";